import { Box, Typography } from "@mui/material";
import I18n from "i18next";
import FieldMappingPanel from "./FieldMappingPanel";
import BatchSettings from "./BatchSettings";
import BatchStatus from "./BatchStatus";

const sx = {
  root: {
    color: "darkBlue.c100"
  },
  header: {
    color: "darkBlue.c100"
  },
  description: {
    color: "darkBlue.c100",
    width: "640px",
    paddingTop: "20px"
  }
};

export default function BatchConfigurationMain({
  fieldMappingRows,
  hasHeaderRow,
  checkBoxValues,
  permissions,
  portfolios,
  inputFolder,
  outputFolder,
  batchStatusRecord,
  batchRetrieval,
  batchPlacement,
  selectedPortfolio,
  loading,
  showAlert,
  selectedDate,
  isPartnerChanged,
  folderError,
  showNotification,
  showBatchStatusError,
  pagination,
  onPageRoute,
  onDisabledSection,
  onAlertClose,
  onCheckBoxChange,
  onBatchRetrieval,
  onBatchPlacement,
  onPortfolioChange,
  onInputFolder,
  onOutputFolder,
  onUpdate,
  onFromDateSelect,
  onToDateSelect,
  onHandleRefresh
}) {
  return (
    <Box sx={sx.root}>
      <Box>
        <Typography variant="h4" sx={sx.header}>
          {I18n.t("batchProcessing.batchProcessingConfiguration")}
        </Typography>
        <Typography variant="body2" sx={sx.description}>
          {I18n.t("batchProcessing.batchProcessingDescription")}
        </Typography>
      </Box>
      <BatchStatus
        rows={batchStatusRecord}
        selectedDate={selectedDate}
        showBatchStatusError={showBatchStatusError}
        onAlertClose={onAlertClose}
        pagination={pagination}
        onFromDateSelect={onFromDateSelect}
        onToDateSelect={onToDateSelect}
        onHandleRefresh={onHandleRefresh}
      />
      <BatchSettings
        checkBoxValues={checkBoxValues}
        permissions={permissions}
        portfolios={portfolios}
        batchRetrieval={batchRetrieval}
        batchPlacement={batchPlacement}
        inputFolder={inputFolder}
        outputFolder={outputFolder}
        selectedPortfolio={selectedPortfolio}
        isPartnerChanged={isPartnerChanged}
        loading={loading}
        showAlert={showAlert}
        showNotification={showNotification}
        folderError={folderError}
        onDisabledSection={onDisabledSection}
        onAlertClose={onAlertClose}
        onInputFolder={onInputFolder}
        onOutputFolder={onOutputFolder}
        onCheckBoxChange={onCheckBoxChange}
        onBatchRetrieval={onBatchRetrieval}
        onBatchPlacement={onBatchPlacement}
        onPortfolioChange={onPortfolioChange}
        onUpdate={onUpdate}
      />
      <FieldMappingPanel fieldMappingRows={fieldMappingRows} hasHeaderRow={hasHeaderRow} onPageRoute={onPageRoute} />
    </Box>
  );
}
